import { Link } from 'react-router-dom'
import { formatDayShort } from '../domain/time.ts'
import './DayTabs.css'

/**
 * Day switcher.
 *
 * Also the accessible route to the behaviour the horizontal swipe provides — a
 * gesture is not usable by everyone, so it is never the only way to change day.
 */
export function DayTabs({
  days,
  activeDay,
  today,
}: {
  days: readonly string[]
  activeDay: string
  today: string | null
}) {
  return (
    <nav className="day-tabs" aria-label="Festivaldager">
      <ul className="day-tabs__list">
        {days.map((day) => {
          const { weekday, dayOfMonth } = formatDayShort(day)
          const isActive = day === activeDay
          return (
            <li key={day}>
              <Link
                to={`/dag/${day}`}
                className="day-tabs__tab"
                data-active={isActive || undefined}
                aria-current={isActive ? 'page' : undefined}
              >
                <span className="day-tabs__weekday">{weekday}</span>
                <span className="day-tabs__date">{dayOfMonth}</span>
                {day === today && <span className="day-tabs__today" aria-hidden="true" />}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
